import { render, staticRenderFns } from "./LogoWhite.vue?vue&type=template&id=1e6ae4d6&"
import script from "./LogoWhite.vue?vue&type=script&lang=ts&"
export * from "./LogoWhite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports